import { OrderMethod } from '@/domain/models/Order/orderMethod';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { SalesPeriodType } from '@/pages/menu-managements/items/hooks/useMenuManagementItemForm';
import { SearchItem } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import {
  BrandItemDelivery,
  BrandItemEatIn,
  BrandItemTakeout,
  SpecialInstructionsSetting,
} from '@/services/BrandItem';
import { MenuManagementBrandItemService } from '@/services/BrandItem/MenuManagementItemService';
export type ShowBrandItemResponse = {
  title: Title;
  image_url: string | null;
  limit_of_purchase: number | null;
  memo: string | null;
  description: string | null;
  sales_start_at: string | null;
  sales_end_at: string | null;
  takeout: BrandItemTakeout | null;
  delivery: BrandItemDelivery | null;
  eat_in: BrandItemEatIn | null;
  order_methods: OrderMethod[];
  can_serve_alone: boolean;
  is_auth_required: boolean;
  brand_option_group_sort_objects: SearchItem[];
  sales_period_type: SalesPeriodType;
  relative_sales_start_at: number | null;
  relative_sales_end_at: number | null;
  special_instructions_setting: SpecialInstructionsSetting | null;
};

export const useMenuManagementBrandItemShow = async (
  id: string
): Promise<ShowBrandItemResponse> => {
  const menuManagementBrandItemService = new MenuManagementBrandItemService(
    getClient()
  );
  try {
    const res = await menuManagementBrandItemService.show(id);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
